import { TagAttribute } from '../../../types/TagAttribute';

import styles from './Tag.module.scss';

import type { FC } from 'react';

export type TagProps = {
  tagAttribute: TagAttribute[];
};

// CategoryMid Styled
const Tags: FC<TagProps> = ({ tagAttribute }) => (
  <>
    {tagAttribute.map((tag) => (
      <a className={styles['mid-primary']} key={tag.id} href={tag.link}>
        {tag.text}
      </a>
    ))}
  </>
);

export const Tag: FC<TagProps> = ({ tagAttribute }) => (
  <div>
    <Tags tagAttribute={tagAttribute} />
  </div>
);
